import { Box, Flex } from '@chakra-ui/react';

import { FlexItem } from '@r-client/shared/ui/flex';

export const Footer = () => {
  return (
    <Box
      as="footer"
      position="fixed"
      w="full"
      h="28px"
      bottom="0"
      backgroundColor="white"
      borderTop="1px"
      borderColor="gray.200"
      overflowX="auto"
    >
      <Flex gap={{ base: '5px', md: '15px' }} ml={{ base: '8px', md: '30px' }}>
        <FlexItem>{/* Footer content goes here */}</FlexItem>
      </Flex>
    </Box>
  );
};
